import { Card, Text, Group, Image, Skeleton } from "@mantine/core";
import chartPlaceholder from "../assets/chart-placeholder.png";
import { observer } from "mobx-react-lite";
import { ReactNode } from "react";

interface CountedValueCardProps {
  title: string;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  value?: number | string;
  subtext?: string;
  selected?: boolean;
}

// CountedValueCard displays loading symbols if body and todayEstimate are not provided, acting as a
// skeleton
const CountedValueCard: React.FC<CountedValueCardProps> = observer(
  ({ title, onClick, value, subtext, selected }) => {
    const m = 26;
    const style = selected ? { border: "2px solid #BD6DFF" } : {};
    return (
      <Card
        shadow="sm"
        padding="sm"
        radius="md"
        withBorder
        style={style}
        onClick={onClick}
      >
        <Text ml={m} fw={650}>
          <b>{title}</b>
        </Text>

        <Group
          justify="space-between"
          preventGrowOverflow={false}
          style={{ overflow: "hidden", flexWrap: "nowrap" }}
        >
          {value !== undefined ? (
            <Text size="xl" ml={m} fw={775}>
              {typeof value === "string" ? value : value.toLocaleString()}
            </Text>
          ) : (
            <Skeleton width={80} height={33} ml={m} />
          )}
          <Image src={chartPlaceholder} height={60} mr={36} />
        </Group>

        {subtext !== undefined ? (
          <Text ml={m} size="sm" c="dimmed">
            {subtext}
          </Text>
        ) : (
          <Skeleton width={60} height={15} ml={m} />
        )}
      </Card>
    );
  },
);

export default CountedValueCard;
